import requireJs from './requireJs';

export const getPDFThumb = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (fileReader.result) {
        const typedarray = new Uint8Array(fileReader.result as ArrayBuffer);
        requireJs(
          'https://ssl-static2.720static.com/js/pdfjs-3.3.122.2/build/pdf.js'
        ).then(() => {
          if (!(window as any).pdfjsLib) {
            reject(new Error('pdf js not supported'));
            return;
          }
          const loadingTask = (window as any).pdfjsLib.getDocument(typedarray);
          loadingTask.promise.then((pdf: any) => {
            if (pdf.numPages > 0) {
              pdf.getPage(1).then((page: any) => {
                const viewport = page.getViewport({ scale: 1 });
                const canvas = document.createElement('canvas');
                canvas.width = 1024;
                canvas.height = 1024;
                const scale = Math.min(
                  canvas.width / viewport.width,
                  canvas.height / viewport.height
                );
                const offsetX =
                  viewport.width > viewport.height
                    ? 0
                    : (canvas.width - viewport.width * scale) / 2;
                const offsetY =
                  viewport.width > viewport.height
                    ? (canvas.height - viewport.height * scale) / 2
                    : 0;

                return page
                  .render({
                    canvasContext: canvas.getContext('2d'),
                    viewport: page.getViewport({ scale, offsetX, offsetY }),
                  })
                  .promise.then(() => {
                    const dataURL = canvas.toDataURL('image/jpeg');
                    fetch(dataURL)
                      .then((res: Response) => res.blob())
                      .then((blob: Blob) => {
                        resolve(new File([blob], 'thumb.jpg'));
                      })
                      .catch((err: Error) => reject(err));
                  });
              });
            }
          });
        });
      }
    };
    fileReader.readAsArrayBuffer(file);
  });
};
